import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bf552c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/sales_home.css?vue&type=style&index=0&id=2bf552c8&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=2bf552c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf552c8",
  null
  
)

export default component.exports